import Vue from 'vue';
import GMap from "\u002Fvar\u002Fwww\u002Fkartapolis-frontend-staging\u002Fsource\u002Fnode_modules\u002Fnuxt-gmaps\u002Fcomponents\u002FGMap.vue";
import GMapMarker from "\u002Fvar\u002Fwww\u002Fkartapolis-frontend-staging\u002Fsource\u002Fnode_modules\u002Fnuxt-gmaps\u002Fcomponents\u002FGMapMarker.vue";
import GMapCircle from "\u002Fvar\u002Fwww\u002Fkartapolis-frontend-staging\u002Fsource\u002Fnode_modules\u002Fnuxt-gmaps\u002Fcomponents\u002FGMapCircle.vue";
import GMapInfoWindow from "\u002Fvar\u002Fwww\u002Fkartapolis-frontend-staging\u002Fsource\u002Fnode_modules\u002Fnuxt-gmaps\u002Fcomponents\u002FGMapInfoWindow.vue";
export default(context, inject) =>{
  Vue.component('GMap', GMap);
  Vue.component('GMapMarker', GMapMarker);
  Vue.component('GMapCircle', GMapCircle);
  Vue.component('GMapInfoWindow', GMapInfoWindow);
  inject('GMaps', {apiKey: "AIzaSyBw8FNvk1ih3GILvmGsWb2in71ww3eXPAI", loaded: false, libraries: undefined})
}